
































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import Annoucement from "@/models/porposal/porposal.model";
import { BTableColumnType } from "@/enums/BTableColumnType";
import AnnoucementService from "@/services/porposal.service";
import { PermissionValue } from "@/enums/PermissionValue";
import { RowTable } from "@/typings/BRowTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import { ProposalState } from "@/enums/ProposalState";
import ResearchCenterBasicInformationComponent from "@/components/research-center-basic-information/researchCenterBasicInformation.vue";
import fileService from "@/services/file.service";
import ProposalUserReport from "../../models/porposal/porposalUserReport.model";
import PorposalService from "@/services/porposal.service";
import PorposalUserReportEvaluations from "@/models/porposal/porposalUserReportEvaluations.model";
import User from "../../models/security/user.model";
import DatePickerComponent from "@/components/base-datePicker/base-date-picker.vue";
import BaseSelectPerson from "@/components/base/baseSelectPerson/baseSelectPerson.vue";
import UserBasicInformationComponent from "@/components/user-basic-information/userBasicInformation.vue";
import { ReportEvaluationState } from "@/enums/ReportEvaluationState";
import ProposalDisbursement from "../../models/porposal/proposalDisbursement.model";
import { ProposalReportEvaluationType } from "@/enums/ProposalReportEvaluationType";
import { ReportEvaluationStateValidation } from "@/enums/ReportEvaluationStateValidation";
import BudgetExpenseService from "@/services/budgetExpense.service";
import ProposalBudgetItemExecution from "@/models/porposal/proposalBudgetItemExecution.model";
import { Utils } from "@/core/Utils";
import AnalyticalMatrixEvaluation from '@/models/analyticalMatrixEvaluation.model';

@Component({
  components: {
    ResearchCenterBasicInformationComponent,
    DatePickerComponent,
    BaseSelectPerson,
    UserBasicInformationComponent
  }
})
export default class UserReportTableFondocytComponent extends GenericBTable<
  Annoucement
> {
  @Prop() public refreshTable!: number;
  @Prop() public estado!: ProposalState;
  @Prop() public isFondocyt!: boolean;
  isLoading: boolean = false;

  file: any = null;
  code: string = "";
  codes: string = "";
  loading: boolean = false;
  annoucementId: number = null;
  evaluatorUI: User = null;
  deadlineUI: any = null;
  motivoDevolucion: string = "";
  proposalUserReportModel: any = null;
  showModalEvaluadores: boolean = false;
  showModalInformesNoAprobados: boolean = false;
  isComponentModalActive: boolean = false;
  showAprobarModal: boolean = false;
  currentProposalUserReport: ProposalUserReport = null;
  currentProposalUserReportEvaluations: ProposalUserReport = null;
  disbursement: ProposalDisbursement = new ProposalDisbursement();
  budgetExpenseService: BudgetExpenseService = new BudgetExpenseService();

  enviadoCI: ProposalState = ProposalState.EnviadoCI;
  devueltoCI: ProposalState = ProposalState.DevueltoCI;
  enviadoFC: ProposalState = ProposalState.EnviadoFC;
  devueltoFC: ProposalState = ProposalState.DevueltoFC;
  aprovadoFC: ProposalState = ProposalState.AprobadoFC;

  proposalService: PorposalService = new PorposalService();

  private pendiente: ReportEvaluationState = ReportEvaluationState.Pendiente;
  private aprobado: ReportEvaluationState = ReportEvaluationState.Aprobado;
  private noAprobado: ReportEvaluationState = ReportEvaluationState.NoAprobado;
  budgetEvaluation: ProposalReportEvaluationType =
    ProposalReportEvaluationType.BudgetEvaluation;
  reportEvaluation: ProposalReportEvaluationType =
    ProposalReportEvaluationType.ReportEvaluation;

  todasAprobados: ReportEvaluationStateValidation =
    ReportEvaluationStateValidation.TodasAprobados;
  hayNoAprobados: ReportEvaluationStateValidation =
    ReportEvaluationStateValidation.HayNoAprobados;

  model: any = null;
  showModalEvaluacionesRealizadas: boolean = false;
  budgetExpenses: any = [];
  aprobadaFc = ProposalState.AprobadoFC;

  showMatrizAnalitica: boolean = false;
  currentMatrizAnalitica: Array<AnalyticalMatrixEvaluation> = [];

  created() {
    this.permissionValue = PermissionValue.REPORTEPORPROPUESTA;

    this.tableConfig.controller = `PorposalUserReport/GetReportsByEstadoFondocyt/${this.estado}`;
    this.tableConfig.detailed = true;
    this.tableConfig.rowClass = (row: ProposalUserReport, index: number) =>
      row.projectEndDocument && "is-primary-mescyt";
    this.formatColumns();
  }

  watchReport(row: ProposalUserReport) {
    this.$router.push("/proyecto/reporte/" + row.id);
  }

  setModel(data: any) {
    this.proposalUserReportModel = data;
    this.isComponentModalActive = true;
  }

  getBudgetExpenses() {
    this.budgetExpenseService.getBudgetExpenses().then(response => {
      if (response) {
        this.budgetExpenses = response.filter(x =>
          this.model.porposalBudgetItems.some(y => y.budgetExpenseId == x.id)
        );
      }
    });
  }

  showMatrixEvaluation (evaluations: PorposalUserReportEvaluations, data: any) {
    if (evaluations.analyticalMatrixEvaluations && evaluations.analyticalMatrixEvaluations.length > 0) {
      this.showMatrizAnalitica = true;
      this.currentMatrizAnalitica = evaluations.analyticalMatrixEvaluations;
    } else {
      this.operationNoAllowed();
    }
  }

  async showCurrentEvaluation(
    evaluations: PorposalUserReportEvaluations,
    data: any
  ) {
    
    if (
      evaluations.budgetItemEvaluations &&
      evaluations.budgetItemEvaluations.length > 0 &&
      data
    ) {
      this.loading = true;
      this.model = data;
      for (let i = 0; i < this.model.proposalBudgetItemsExecution.length; i++) {
        const proposalBudgetItemsExecution = this.model
          .proposalBudgetItemsExecution[i];
        proposalBudgetItemsExecution.budgetItemEvaluationUI = evaluations.budgetItemEvaluations.find(
          x =>
            x.proposalBudgetItemExecutionId == proposalBudgetItemsExecution.id
        );
        for (
          let y = 0;
          y <
          proposalBudgetItemsExecution.proposalBudgetSubItemsExecution.length;
          y++
        ) {
          const subItem =
            proposalBudgetItemsExecution.proposalBudgetSubItemsExecution[y];
          subItem.budgetSubItemEvaluationUI = proposalBudgetItemsExecution.budgetItemEvaluationUI.budgetSubItemEvaluations.find(
            x => x.proposalBudgetSubItemExecutionId == subItem.id
          );
        }
      }
      await this.getBudgetExpenses();
      this.loading = false;
      this.showModalEvaluacionesRealizadas = true;
    } else {
      this.operationNoAllowed("No se ha realizado evaluación");
    }
  }

  get totalSpent() {
    if (this.model && this.model.proposalBudgetItemsExecution) {
      return this.model.proposalBudgetItemsExecution.reduce((a, b) => {
        var result = b.proposalBudgetSubItemsExecution.reduce((c, d) => {
          return c + d.amountSpent;
        }, 0);

        return a + result;
      }, 0);
    }
    return 0;
  }

  calculateTotalSpentByBudgetItem(row: ProposalBudgetItemExecution) {
    return row.proposalBudgetSubItemsExecution.reduce((a, b) => {
      return a + b.amountSpent;
    }, 0);
  }

  calculateTotalAmountSpentByBudgetExpense(
    rows: Array<ProposalBudgetItemExecution>
  ) {
    return rows.reduce((a, b) => {
      var result = b.proposalBudgetSubItemsExecution.reduce((c, d) => {
        return c + d.amountSpent;
      }, 0);

      return a + result;
    }, 0);
  }

  formatColumns() {
    let docTitle = new BTableColumn("docTitle", "table.title", true);
    let name = new BTableColumn("name", "table.project", true);
    let description = new BTableColumn(
      "description",
      "table.description",
      true
    );
    let researchCenter = new BTableColumn(
      "researchCenter",
      "table.researchCenter",
      true
    );

    researchCenter.customTemplate = true;
    docTitle.customTemplate = true;
    description.customTemplate = true;
    name.customTemplate = true;
    name.width = "300";
    docTitle.width = "200";
    researchCenter.width = "350";

    if (this.estado == this.devueltoCI || this.estado == this.devueltoFC) {
      let reason = new BTableColumn("reason", "table.reason", true);
      reason.customTemplate = true;
      this.tableConfig.insertColumns(name, researchCenter, description, reason);
    } else {
      this.tableConfig.insertColumns(name, researchCenter, description);
    }

    this.tableConfig.actions.customTemplate = true;
    this.tableConfig.enableDefaultColumns = false;
  }

  @Watch("annoucementId")
  getByAnnoucement() {
    this.tableConfig.whereParams = `Proposal/AnnoucementId eq ${this.annoucementId}`;
    this.tableConfig.reload();
  }

  @Watch("code")
  getByCode() {
    this.tableConfig.whereParams = `contains(Proposal/Code, '${this.code}')`;
    this.tableConfig.reload();
  }

  @Watch("refreshTable")
  onrefreshTable(value: number) {
    if (value > 0) {
      this.tableConfig.reload();
    }
  }

  searchByCode(event: any) {
    if (event.keyCode === 13) {
      this.code = this.codes.trim();
    }
  }

  async downloadFile(file: any) {
    if (file.document.contentType == "application/octet-stream")
      await fileService.downloadOctetFile(
        file.document.id,
        file.document.originalName
      );
    else await fileService.download(file.document.id);
  }

  async verDocument(data: any = null) {
    if (data.isLastResport) {
      if (data.document.contentType == "application/octet-stream")
        await fileService.downloadOctetFile(
          data.document.id,
          data.document.originalName
        );
      else await fileService.download(data.document.id);
      //
      if (data.projectEndDocument.contentType == "application/octet-stream")
        await fileService.downloadOctetFile(
          data.projectEndDocument.id,
          data.projectEndDocument.originalName
        );
      else await fileService.download(data.projectEndDocument.id);
    } else {
      if (data.document.contentType == "application/octet-stream")
        await fileService.downloadOctetFile(
          data.document.id,
          data.document.originalName
        );
      else await fileService.download(data.document.id);
    }
  }

  redirectToApproval(data: any) {
    this.$router.push(`EvaluateLastReport/${data.id}`);
  }

  async displayApprovalModal(data: any) {
    this.cleanDisburstmentModel();
    this.currentProposalUserReport = data;
    this.showAprobarModal = true;
    this.model = data;
  }

  cleanDisburstmentModel() {
    this.disbursement = new ProposalDisbursement();
    this.file = null;
  }

  danger(reportEvaluation, budgetEvaluation) {
    let msgReport, msgBudget, hr = "";
    msgReport = (reportEvaluation == this.hayNoAprobados) ? `Se recomienda agregar más evaluadores al <strong> informe </strong>` : "";
    msgBudget = (budgetEvaluation == this.hayNoAprobados) ? `Se recomienda agregar más evaluadores al fomulario de <strong> ejecución presupuestaria </strong> ó devolver el reporte para realizar los arreglos de lugar.` : "";
    hr = (msgReport && msgBudget) ? `<hr style="margin-bottom: 10px; margin-top: 10px;"/>` : "";
    const notif = this.$buefy.notification.open({
      duration: 10000,
      message: `${msgReport} ${hr} ${msgBudget}`,
      position: "is-bottom-right",
      type: "is-danger",
      hasIcon: true
    });
  }
  cleanObject(sendObject: ProposalUserReport) {
    sendObject.document = null;
    sendObject.porposalBudgetItems = [];
    sendObject.proposal = null;
    sendObject.researchCenter = null;
    sendObject.proposalBudgetItemsExecution = [];
  }

  async confirmApproval() {
    if (
      this.file &&
      this.disbursement.amount > 0 &&
      this.disbursement.disbursementDate &&
      this.disbursement.deliveryDate &&
      this.disbursement.requestDate &&
      this.disbursement.tradeNumber
    ) {
      this.loading = true;
      this.showAprobarModal = false;

      // disbursement
      let doc = await fileService.upload(this.file as File);
      doc.refEntityKey = "Id";
      doc.refEntityName = "ProposalDisbursement";
      this.disbursement.document = doc;
      this.disbursement.porposalId = this.currentProposalUserReport.proposalId;
      let disbursementCreated = await this.proposalService.addPorposalDisbursement(
        this.disbursement
      );

      // report
      this.currentProposalUserReport.state = ProposalState.AprobadoFC;
      this.currentProposalUserReport.reason = null;
      this.currentProposalUserReport.proposalDisbursementId =
        disbursementCreated.id;

      var sendObject = Utils.mapToObject(
        this.currentProposalUserReport,
        new ProposalUserReport()
      ) as ProposalUserReport;
      this.cleanObject(sendObject);

      await this.proposalService.updateProposalUserReport(
        this.currentProposalUserReport.id,
        sendObject
      );

      this.currentProposalUserReport = null;
      this.cleanDisburstmentModel();
      this.operationSuccess("Se ha aprobado el informe de manera exitosa");
      this.$emit("refreshTable", true);
      this.loading = false;
    } else {
      this.operationNoAllowed("Faltan campos por completar");
    }
  }

  async confirmReturn() {
    if (this.motivoDevolucion && this.motivoDevolucion != "") {
      this.isLoading = true;
      this.proposalUserReportModel.state = this.isFondocyt
        ? ProposalState.DevueltoFC
        : ProposalState.DevueltoCI;
      this.proposalUserReportModel.reason = this.motivoDevolucion;
      await this.proposalService.updateProposalUserReport(
        this.proposalUserReportModel.id,
        this.proposalUserReportModel
      );
      this.isLoading = false;
      this.isComponentModalActive = false;
      this.operationSuccess("Se ha devuelto el informe de manera exitosa");
      this.$emit("refreshTable", true);
      this.cleanModel();
    } else {
      this.$buefy.toast.open({
        message: "Debe escribir un motivo.",
        type: "is-warning",
        duration: 2000
      });
    }
  }

  cleanModel() {
    this.proposalUserReportModel = null;
    this.motivoDevolucion = null;
  }

  showRazonUltimoMovimiento(movimientos: any[]) {
    return movimientos[movimientos.length - 1].razon;
  }

  showModalEvaluacionesNoAprobadas(proposalUserReport: ProposalUserReport) {
    this.currentProposalUserReportEvaluations = proposalUserReport;
    this.showModalInformesNoAprobados = true;
  }

  showEvaluatorsModal(proposalUserReport: ProposalUserReport) {
    this.showModalEvaluadores = true;
    this.currentProposalUserReport = proposalUserReport;
    this.initEvaluatorAndDeadline();
  }

  addEvaluator() {
    if (
      this.currentProposalUserReport &&
      this.currentProposalUserReport.porposalUserReportEvaluations.length > 0
    ) {
      if (
        this.currentProposalUserReport.porposalUserReportEvaluations.some(
          x =>
            x.evaluatorId == this.evaluatorUI.id &&
            x.proposalReportEvaluationType ==
              ProposalReportEvaluationType.ReportEvaluation
        )
      ) {
        let porposalUserReportEvaluation = this.currentProposalUserReport.porposalUserReportEvaluations.find(
          x =>
            x.evaluatorId == this.evaluatorUI.id &&
            x.proposalReportEvaluationType ==
              ProposalReportEvaluationType.ReportEvaluation
        );
        if (porposalUserReportEvaluation.deleted) {
          porposalUserReportEvaluation.deleted = false;
          porposalUserReportEvaluation.deadline = this.deadlineUI;
          porposalUserReportEvaluation.evaluator = this.evaluatorUI;
          this.initEvaluatorAndDeadline();
        } else {
          this.operationNoAllowed("Ya se ha ingresado ese evaluador");
        }
      } else {
        this.pushEvaluator();
      }
    } else {
      this.pushEvaluator();
    }
  }

  addBudgetEvaluator() {
    if (
      this.currentProposalUserReport &&
      this.currentProposalUserReport.porposalUserReportEvaluations.length > 0
    ) {
      if (
        this.currentProposalUserReport.porposalUserReportEvaluations.some(
          x =>
            x.evaluatorId == this.evaluatorUI.id &&
            x.proposalReportEvaluationType ==
              ProposalReportEvaluationType.BudgetEvaluation
        )
      ) {
        let porposalUserReportEvaluation = this.currentProposalUserReport.porposalUserReportEvaluations.find(
          x =>
            x.evaluatorId == this.evaluatorUI.id &&
            x.proposalReportEvaluationType ==
              ProposalReportEvaluationType.BudgetEvaluation
        );
        if (porposalUserReportEvaluation.deleted) {
          porposalUserReportEvaluation.deleted = false;
          porposalUserReportEvaluation.deadline = this.deadlineUI;
          porposalUserReportEvaluation.evaluator = this.evaluatorUI;
          porposalUserReportEvaluation.proposalReportEvaluationType =
            ProposalReportEvaluationType.BudgetEvaluation;
          this.initEvaluatorAndDeadline();
        } else {
          this.operationNoAllowed("Ya se ha ingresado ese evaluador");
        }
      } else {
        this.pushEvaluator(true);
      }
    } else {
      this.pushEvaluator(true);
    }
  }

  eliminarEvaluador(
    evaluatorId: any,
    index: number,
    evaluationType: ProposalReportEvaluationType
  ) {
    let porposalUserReportEvaluation = this.currentProposalUserReport.porposalUserReportEvaluations.find(
      x =>
        x.evaluatorId == evaluatorId &&
        x.proposalReportEvaluationType == evaluationType
    );
    if (porposalUserReportEvaluation.id > 0)
      porposalUserReportEvaluation.deleted = true;
    else
      this.currentProposalUserReport.porposalUserReportEvaluations = this.currentProposalUserReport.porposalUserReportEvaluations.filter(
        x =>
          x.evaluatorId != evaluatorId &&
          x.proposalReportEvaluationType == evaluationType
      );
  }

  async enviarEvaluadores() {
    this.loading = true;
    this.showModalEvaluadores = false;
    await this.proposalService.updateProposalUserReport(
      this.currentProposalUserReport.id,
      this.currentProposalUserReport
    );
    this.operationSuccess();
    this.currentProposalUserReport = null;
    this.loading = false;
    this.tableConfig.reload();
  }

  initEvaluatorAndDeadline() {
    this.evaluatorUI = null;
    this.deadlineUI = null;
  }

  pushEvaluator(isBudgetEvaluation = null) {
    let porposalUserReportEvaluation = new PorposalUserReportEvaluations();
    porposalUserReportEvaluation.evaluatorId = this.evaluatorUI.id;
    porposalUserReportEvaluation.evaluator = this.evaluatorUI;
    porposalUserReportEvaluation.deadline = this.deadlineUI;
    if (isBudgetEvaluation)
      porposalUserReportEvaluation.proposalReportEvaluationType =
        ProposalReportEvaluationType.BudgetEvaluation;
    this.currentProposalUserReport.porposalUserReportEvaluations.push(
      porposalUserReportEvaluation
    );
    this.initEvaluatorAndDeadline();
    console.log(this.currentProposalUserReport.porposalUserReportEvaluations);
  }
}
